import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { UserContext } from "../context/UserContext"; // ✅ Import Context
import BottomNavigation from "../components/BottomNavigation";

function Account() {
    const navigate = useNavigate();
    const [showLogoutModal, setShowLogoutModal] = useState(false);

    // 🔥 FIX: Context se 'setUser' hatakar apna 'logout' function nikal liya
    const { user, loading, logout } = useContext(UserContext);

    // Logout Logic
    const handleLogout = () => {
        logout(); // 🔥 MAGIC: Ab ye context wala logout chalega aur saara data (Tokens + User + Referral Cache) saaf kar dega
        navigate("/auth");
    };

    // ✅ SHIMMER LOADER (UI Maroon Theme)
    if (loading) return (
        <div style={{ minHeight: "100vh", background: "#f3f4f6" }}>

            {/* === SHIMMER HEADER === */}
            <div className="pb-5 pt-4 px-3 position-relative placeholder-glow"
                style={{ background: "linear-gradient(135deg, #800000 0%, #4A0000 100%)", borderBottomLeftRadius: "30px", borderBottomRightRadius: "30px", height: "260px", boxShadow: "0 10px 20px rgba(128,0,0,0.15)" }}>

                {/* Avatar & Name Shimmer */}
                <div className="d-flex align-items-center gap-3 mb-4 pt-2">
                    <div className="placeholder rounded-circle bg-light opacity-50" style={{ width: "80px", height: "80px" }}></div>
                    <div className="flex-grow-1">
                        <span className="placeholder col-6 bg-light opacity-50 rounded mb-2" style={{ height: "20px" }}></span>
                        <span className="placeholder col-4 bg-light opacity-50 rounded d-block" style={{ height: "15px" }}></span>
                    </div>
                </div>

                {/* Stats Shimmer */}
                <div className="d-flex justify-content-between text-center bg-white bg-opacity-10 rounded-4 p-3 border border-white border-opacity-10">
                    <div className="col-3"><span className="placeholder col-8 bg-light opacity-50 rounded"></span></div>
                    <div className="col-3"><span className="placeholder col-8 bg-light opacity-50 rounded"></span></div>
                    <div className="col-3"><span className="placeholder col-8 bg-light opacity-50 rounded"></span></div>
                </div>
            </div>

            <div className="container-fluid px-3 px-md-4" style={{ marginTop: "-30px" }}>

                {/* Wallet Shimmer */}
                <div className="card border-0 shadow-sm mb-4 placeholder-glow" style={{ borderRadius: "20px", height: "100px", background: "#fff" }}>
                    <div className="card-body d-flex align-items-center justify-content-between">
                        <div className="col-5">
                            <span className="placeholder col-12 bg-secondary opacity-25 rounded mb-2"></span>
                            <span className="placeholder col-8 bg-secondary opacity-25 rounded big"></span>
                        </div>
                        <div className="placeholder col-4 bg-secondary opacity-25 rounded-pill" style={{ height: "40px" }}></div>
                    </div>
                </div>

                {/* Menu List Shimmer */}
                <div className="d-flex flex-column gap-3 placeholder-glow">
                    {[1, 2, 3].map((i) => (
                        <div key={i} className="card border-0 shadow-sm rounded-4 p-3" style={{ height: "70px" }}>
                            <div className="d-flex align-items-center h-100">
                                <span className="placeholder rounded-circle bg-secondary opacity-10 me-3" style={{ width: "40px", height: "40px" }}></span>
                                <span className="placeholder col-6 bg-secondary opacity-10 rounded"></span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );

    // Agar user nahi hai (null check), to auth par bhej do
    if (!user) {
        navigate('/login');
        return null;
    }

    // 💰 Wallet Calculation (Safe Check)
    // 💰 Wallet Calculation (Safe Check with 2 Decimal logic)
    let totalBalance = 0;
    if (user.wallet) {
        // Sab kuch number me convert karke add karo aur end me string format me 2 decimal lagao
        totalBalance = (
            Number(user.wallet.deposited || 0) +
            Number(user.wallet.winnings || 0) +
            Number(user.wallet.bonus || 0)
        ).toFixed(2);
    } else {
        totalBalance = "0.00";
    }

    // Stats Calculation
    const matches = user.totalMatches || 0;
    const won = user.totalWon || 0;
    const winRate = (matches > 0 ? ((won / matches) * 100).toFixed(0) : "0") + "%";

    // 🔥 NEW: 100% Verification Logic for Blue Tick
    const isEmailDone = Boolean(user?.isEmailVerified);
    const isPanDone = user?.kyc?.pan?.status === 'VERIFIED';
    const isBankDone = user?.kyc?.bank?.status === 'VERIFIED';
    const isUpiDone = user?.kyc?.upi?.status === 'VERIFIED';

    let progress = 0;
    if (isEmailDone) progress += 25;
    if (isPanDone) progress += 25;
    if (isBankDone) progress += 25;
    if (isUpiDone) progress += 25;

    const isFullyVerified = progress === 100;

    return (
        <>
            <Navbar />
            <div style={{ minHeight: "100vh", background: "#f3f4f6", paddingBottom: "100px" }} className="mt-5 pt-3">

                {/* === HEADER SECTION IN MAROON === */}
                <div
                    className="pb-5 pt-4 px-3 position-relative"
                    style={{
                        background: "linear-gradient(135deg, #800000 0%, #4A0000 100%)",
                        borderBottomLeftRadius: "30px",
                        borderBottomRightRadius: "30px",
                        height: "260px",
                        boxShadow: "0 10px 20px rgba(128,0,0,0.15)"
                    }}
                >
                    {/* User Info */}
                    <div className="d-flex align-items-center gap-3 text-white mb-4 position-relative z-1">

                        {/* Profile Photo */}
                        <div className="position-relative">
                            {user.avatar ? (
                                <img
                                    src={user.avatar}
                                    alt="Profile"
                                    className="rounded-circle border border-4 border-white shadow bg-white"
                                    style={{ width: "80px", height: "80px", objectFit: "cover" }}
                                    onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
                                />
                            ) : (
                                <div className="bg-white bg-opacity-25 rounded-circle d-flex align-items-center justify-content-center fw-bold fs-2 text-white border border-4 border-white shadow"
                                    style={{ width: '80px', height: '80px' }}>
                                    {user.name ? user.name.charAt(0).toUpperCase() : "U"}
                                </div>
                            )}

                            {/* 🔥 NEW: BLUE TICK IF 100% VERIFIED */}
                            {isFullyVerified && (
                                <i
                                    className="bi bi-patch-check-fill position-absolute"
                                    style={{
                                        bottom: "0px", right: "0px",
                                        color: "#1d9bf0", // Verified Blue
                                        fontSize: "22px",
                                        background: "white",
                                        borderRadius: "50%",
                                        lineHeight: "1",
                                        padding: "0px",
                                        border: "2px solid white"
                                    }}
                                    title="Fully Verified User"
                                ></i>
                            )}
                        </div>

                        <div className="flex-grow-1">
                            <h3 className="fw-bold mb-0 text-capitalize">{user.name}</h3>
                            <p className="text-white-50 mb-0 small">{user.mobile || user.email}</p>
                        </div>
                    </div>

                    {/* Stats Row */}
                    <div className="d-flex justify-content-between text-center text-black bg-white rounded-4 p-3 border border-white border-opacity-10 backdrop-blur">
                        <div>
                            <h5 className="fw-bold mb-0">{matches}</h5>
                            <small className="fw-bold" style={{ fontSize: "10px" }}>MATCHES</small>
                        </div>
                        <div className="border-end border-white border-opacity-25"></div>
                        <div>
                            <h5 className="fw-bold mb-0">{won}</h5>
                            <small className="fw-bold" style={{ fontSize: "10px" }}>WON</small>
                        </div>
                        <div className="border-end border-white border-opacity-25"></div>
                        <div>
                            <h5 className="fw-bold mb-0">{winRate}</h5>
                            <small className="fw-bold" style={{ fontSize: "10px" }}>WIN RATE</small>
                        </div>
                    </div>


                </div>


                <div className="container-fluid px-3 px-md-4" style={{ marginTop: "-30px" }}>

                    {/* === WALLET CARD IN MAROON/RED TONE === */}
                    <div className="card border-0 shadow-lg mb-4 text-white position-relative overflow-hidden"
                        style={{ borderRadius: "20px", background: "linear-gradient(135deg, #A00000 0%, #6A0000 100%)" }}>
                        <div style={{ cursor: "pointer" }} className="card-body p-3 d-flex justify-content-between align-items-center position-relative z-1" onClick={() => navigate("/wallet")}>
                            <div>
                                <small className="d-block opacity-75 fw-bold">TOTAL BALANCE</small>
                                <h2 className="fw-bold mb-0">₹{totalBalance}</h2>
                            </div>
                        </div>
                        <i className="bi bi-currency-rupee position-absolute top-0 end-0 display-1 text-white opacity-25 me-n3 mt-n2"></i>
                    </div>



                    {/* === MENU LIST === */}
                    <h6 className="fw-bold text-muted ps-2 mb-3 text-uppercase small ls-1">Account Settings</h6>

                    <div className="d-flex flex-column gap-3">
                        <div className="card border-0 shadow-sm rounded-4 p-3" onClick={() => navigate("/profile")} style={{ cursor: "pointer" }}>
                            <div className="d-flex align-items-center">
                                <i className="bi bi-person-fill fs-4 text-primary me-3"></i>
                                <div className="flex-grow-1"><h6 className="mb-0">My Profile</h6><small className="text-muted">Edit details</small></div>
                                <i className="bi bi-chevron-right text-muted"></i>
                            </div>
                        </div>

                        <div className="card border-0 shadow-sm rounded-4 p-3" onClick={() => navigate("/verify-account")}>
                            <div className="d-flex align-items-center" style={{ cursor: "pointer" }}>
                                <i className="bi bi-shield-fill-check fs-4 text-success me-3"></i>
                                <div className="flex-grow-1"><h6 className="mb-0">Verify Account</h6><small className="text-muted">KYC Status</small></div>
                                <i className="bi bi-chevron-right text-muted"></i>
                            </div>
                        </div>

                        <div className="card border-0 shadow-sm rounded-4 p-3 " onClick={() => navigate("/playing-history")}>
                            <div className="d-flex align-items-center" style={{ cursor: "pointer" }}>
                                <i className="bi bi-clock-history fs-4 text-warning me-3"></i>
                                <div className="flex-grow-1"><h6 className="mb-0 cursor-pointer">Playing History</h6><small className="text-muted">View Stats</small></div>
                                <i className="bi bi-chevron-right text-muted"></i>
                            </div>
                        </div>
                    </div>

                    {/* === LOGOUT IN MAROON THEME === */}
                    <div className="mt-4">
                        <button
                            className="btn w-100 py-3 rounded-4 bg-white fw-bold shadow-sm border-0 d-flex align-items-center justify-content-center gap-2"
                            onClick={() => setShowLogoutModal(true)}
                            style={{ color: "#800000" }}
                        >
                            <i className="bi bi-box-arrow-right fs-5"></i> Log Out
                        </button>

                        <div className="text-center mt-3"><small className="text-muted">Win11 Fantasy v1.0</small></div>
                    </div>

                </div>



                {/* === LOGOUT MODAL IN MAROON THEME === */}
                {showLogoutModal && (
                    <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                        style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1050 }}>
                        <div className="card border-0 shadow-lg rounded-4 p-4 bg-white animate__animated animate__zoomIn" style={{ maxWidth: '350px', width: '90%' }}>
                            <div className="text-center mb-3">
                                <div className="rounded-circle d-inline-flex align-items-center justify-content-center"
                                    style={{ width: '60px', height: '60px', backgroundColor: '#ffe6e6', color: '#800000' }}>
                                    <i className="bi bi-box-arrow-right fs-3"></i>
                                </div>
                                <h5 className="fw-bold mt-2 text-dark">Log Out?</h5>
                                <p className="text-muted mb-0 small px-2">Are you sure you want to log out from your account?</p>
                            </div>
                            <div className="d-flex gap-2 mt-2">
                                <button className="btn btn-light w-100 fw-bold rounded-pill" onClick={() => setShowLogoutModal(false)}>Cancel</button>
                                <button className="btn w-100 fw-bold rounded-pill shadow-sm text-white"
                                    onClick={handleLogout}
                                    style={{ background: "linear-gradient(135deg, #800000 0%, #4A0000 100%)", border: "none" }}>
                                    Yes, Logout
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <style>{` .backdrop-blur { backdrop-filter: blur(5px); } .ls-1 { letter-spacing: 1px; }`}</style>
            </div>
            <BottomNavigation />
        </>
    );
}

export default Account;